import { axiosWithAuth } from "helpers";

export const normalizationService = {
	getNormalizationFiles,
	deleteNormalizedData,
	normalizeData,
	getMerchantsChanges,
};

const RESIDUALS_API_URL = process.env.REACT_APP_API_URL_RESIDUALS;

function getNormalizationFiles(paidMonth, paidYear, searchFor) {
	const options = {
		method: "GET",
		params: {
			search_for: searchFor,
		},
		url: `${RESIDUALS_API_URL}/api/normalization_data/${paidYear}/${paidMonth}`,
	};

	return axiosWithAuth(options);
}

function deleteNormalizedData(paidMonth, paidYear, sourceType) {
	const options = {
		method: "DELETE",
		url: `${RESIDUALS_API_URL}/api/normalization_data/${paidYear}/${paidMonth}/${sourceType}`,
	};

	return axiosWithAuth(options);
}

function normalizeData(paidMonth, paidYear, sourceType) {
	const options = {
		method: "POST",
		url: `${RESIDUALS_API_URL}/api/normalization_data/${paidYear}/${paidMonth}/${sourceType}/normalize`,
	};

	return axiosWithAuth(options);
}

function getMerchantsChanges({ paidMonth, paidYear, page }) {
	const options = {
		method: "GET",
		params: {
			page_size: 5,
			page_index: page,
		},
		url: `${RESIDUALS_API_URL}/api/normalization_data/${paidYear}/${paidMonth}/merchants/changes`,
	};

	return axiosWithAuth(options);
}
